import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
//import { ClaimService } from '../../../services/Claim/claim.service'
//import { UploaderSettings, UploadEntity, mohValidators, ModalService, MessageType, ToggleOption } from 'moh-package';

//import { ModalService } from 'moh-package';
//import { ClmClaimDetails } from '../../../models/claim/ClmClaimDetails';
//import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'moh-claim',
  templateUrl: './claim.component.html',
  styleUrls: ['./claim.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ClaimComponent implements OnInit {

 // form: FormGroup;
 // clmObj: ClmClaimDetails;
  //constructor(private formBuilder: FormBuilder) {
  //}
  constructor() { }

  //private idIsNotValid = false;
  //private idNotValidMessage = "הערכים שמולאו בשדות : שם פרטי תובעת, שם משפחה תובע/ת,  ומספר זהות אינם מוכרים במרשם אוכלוסין. נא לעדכן ולשלוח שוב."
  //private successMessage = "הטופס נשלח בהצלחה למרכז הלאומי לנפגעי גזזת. לבירור לגבי מצב הטיפול בטופס, יש לפנות למוקד הפניות של משרד הבריאות, ולציין את הקוד האישי שקיבלת בעבר ממחלקת גזזת.";
  //private failureMessage = "ישנה בעיה בשליחת הטופס. נסה שוב. אם הבעיה חוזרת, יש לפנות למוקד קול הבריאות.";

  //constructor(private formBuilder: FormBuilder, private clmService: ClaimService,
  //  private modal: ModalService) { }

  ngOnInit() {

   // this.form = this.formBuilder.group({
      //cccClaimerDetails: []
     // HasAdvocate: [false],
      //AdvocateDetails: [],
      //WorseDetails: [],
     // MedicalDocuments: this.formBuilder.array([new FormControl()], mohValidators.required()),
     // Agreement: ['', [mohValidators.requiredTrue()]]
   // });

   // this.slideToggleOptions = [new ToggleOption('כן', true), new ToggleOption('לא', false)];

   // this.initializeDocSettings();
  }

  //sendClaimForm() {

    ////this.clmObj = new ClmClaimDetails(this.form.value);

    //this.clmObj.IDIsNotValid = this.idIsNotValid;

  //  this.clmService.sendClaimRequest(this.clmObj).subscribe(

  //    (res) => {
  //      this.handleResponse(res);
  //    },
  //    (error) => {
  //      this.modal.errorMsg('', this.failureMessage, 'אישור');
  //      console.log(error)
  //    });

  //}

  //private handleResponse(response) {

  //  if (response['statusCode'] == 404 && !this.idIsNotValid) {

  //    this.modal.infoMsg(this.idNotValidMessage, '', 'אישור', false).then((result) => {

  //      this.idIsNotValid = true;

  //    });
  //  }

  //  else if (response['statusCode'] == 200 || response['statusCode'] == 404 && this.idIsNotValid) {
  //    this.modal.successMsg('', this.successMessage, 'אישור');
  //  }

  //  else {
  //    this.modal.errorMsg('', this.failureMessage, 'אישור');
  //  }
  //}
}



// WEBPACK FOOTER //
// E:/Develop/MOH.Gazezet/Dev/MOH.Gazzezet/MOH.Gazzezet/src/app/components/claim/claim/claim.component.ts